var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIronTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75965 7.75006H2C1.58579 7.75006 1.25 7.41427 1.25 7.00006C1.25 6.58584 1.58579 6.25006 2 6.25006H4.99127C4.99751 6.24998 5.00375 6.24998 5.01 6.25006H18.99C18.9962 6.24998 19.0025 6.24998 19.0087 6.25006H22C22.4142 6.25006 22.75 6.58584 22.75 7.00006C22.75 7.41427 22.4142 7.75006 22 7.75006H19.2403L13.2903 12.0001L19.4359 16.3898C19.773 16.6305 19.8511 17.0989 19.6103 17.436C19.3695 17.773 18.9011 17.8511 18.5641 17.6104L12 12.9217L5.43593 17.6104C5.09887 17.8511 4.63046 17.773 4.3897 17.436C4.14894 17.0989 4.22701 16.6305 4.56407 16.3898L10.7097 12.0001L4.75965 7.75006Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIronTable);
export default __webpack_public_path__ + "static/media/iron-table.c6a842b150b1afcc110f019211be285a.svg";
export { ForwardRef as ReactComponent };